import { render, staticRenderFns } from "./ClientProfileDueStatements.vue?vue&type=template&id=105c2d19&scoped=true&"
import script from "./ClientProfileDueStatements.vue?vue&type=script&lang=js&"
export * from "./ClientProfileDueStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105c2d19",
  null
  
)

export default component.exports